// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PGWThkOn3I85884aKIS7{align-items:center;gap:8px;display:flex}.BRi_mOYAgN0PUUFwdtam{cursor:pointer;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `PGWThkOn3I85884aKIS7`,
	"link": `BRi_mOYAgN0PUUFwdtam`
};
export default ___CSS_LOADER_EXPORT___;
